import * as signalR from '@microsoft/signalr';
import { from, Subject } from 'rxjs';

import ENVIRONMENT from '@/environments/environment';

import { ReceiveEventsEnum, SendEventsEnum } from './types';

const connection = new signalR.HubConnectionBuilder()
  .withUrl(
    ENVIRONMENT.URL_SIGNALR
      || 'https://dev-ws-draft.peppermoneytest.es/pepperonehub',
  )
  .build();

function associateEvent(
  connection: signalR.HubConnection,
  eventType: ReceiveEventsEnum,
  subject: Subject<void>,
) {
  connection.on(eventType, (data) => subject.next(data));
}

class HubClient {
  ocrStartSubject = new Subject<void>();

  ocrEndSubject = new Subject<void>();

  paymentStartSubject = new Subject<void>();

  paymentEndSubject = new Subject<void>();

  bankreaderStartSubject = new Subject<void>();

  bankreaderEndSubject = new Subject<void>();

  ibanSelectionSubject = new Subject<void>();

  decisionResultSubject = new Subject<void>();

  signatureStartSubject = new Subject<void>();

  signatureEndSubject = new Subject<void>();

  activationSubject = new Subject<void>();

  decisionRedSubject = new Subject<void>();

  denegationWtdSubject = new Subject<void>();

  denegationTudSubject = new Subject<void>();

  constructor() {
    associateEvent(
      connection,
      ReceiveEventsEnum.OCR_START,
      this.ocrStartSubject,
    );
    associateEvent(connection, ReceiveEventsEnum.OCR_END, this.ocrEndSubject);
    associateEvent(
      connection,
      ReceiveEventsEnum.PAYMENT_START,
      this.paymentStartSubject,
    );
    associateEvent(
      connection,
      ReceiveEventsEnum.PAYMENT_END,
      this.paymentEndSubject,
    );
    associateEvent(
      connection,
      ReceiveEventsEnum.BANKREADER_START,
      this.bankreaderStartSubject,
    );
    associateEvent(
      connection,
      ReceiveEventsEnum.BANKREADER_END,
      this.bankreaderEndSubject,
    );
    associateEvent(
      connection,
      ReceiveEventsEnum.IBAN_SELECTION,
      this.ibanSelectionSubject,
    );
    associateEvent(
      connection,
      ReceiveEventsEnum.DECISION_RESULT,
      this.decisionResultSubject,
    );
    associateEvent(
      connection,
      ReceiveEventsEnum.SIGNATURE_START,
      this.signatureStartSubject,
    );
    associateEvent(
      connection,
      ReceiveEventsEnum.SIGNATURE_END,
      this.signatureEndSubject,
    );
    associateEvent(
      connection,
      ReceiveEventsEnum.ACTIVATION,
      this.activationSubject,
    );
    associateEvent(
      connection,
      ReceiveEventsEnum.DECISION_RED,
      this.decisionRedSubject,
    );
    associateEvent(
      connection,
      ReceiveEventsEnum.DENEGATION_WTD,
      this.denegationWtdSubject,
    );
    associateEvent(
      connection,
      ReceiveEventsEnum.DENEGATION_TUD,
      this.denegationTudSubject,
    );
  }

  connect() {
    return from(connection.start());
  }

  sendToken(token: string) {
    return from(connection.send(SendEventsEnum.START, token));
  }

  disconnect() {
    return from(connection.stop());
  }

  get state() {
    return connection.state;
  }

  ocrStartListener = () => this.ocrStartSubject.asObservable();

  ocrEndListener = () => this.ocrEndSubject.asObservable();

  paymentStartListener = () => this.paymentStartSubject.asObservable();

  paymentEndListener = () => this.paymentEndSubject.asObservable();

  bankreaderStartListener = () => this.bankreaderStartSubject.asObservable();

  bankreaderEndListener = () => this.bankreaderEndSubject.asObservable();

  ibanSelectionListener = () => this.ibanSelectionSubject.asObservable();

  decisionResultListener = () => this.decisionResultSubject.asObservable();

  signatureStartListener = () => this.signatureStartSubject.asObservable();

  signatureEndListener = () => this.signatureEndSubject.asObservable();

  activationListener = () => this.activationSubject.asObservable();

  decisionRedListener = () => this.decisionRedSubject.asObservable();

  denegationWtdListener = () => this.denegationWtdSubject.asObservable();

  denegationTudListener = () => this.denegationTudSubject.asObservable();
}

const hubInstance = new HubClient();

export default hubInstance;
